import * as constants from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.bankfeeds, action) {
  switch (action.type) {

    case constants.GET_BANKFEEDS: {
        return { ...state, bankfeeds: action.payload };
    }

    case constants.CLEAR_BANKFEEDS: {
        return { ...state, bankfeeds: [], apiError: false, loadCompleted: false };
    }

    case constants.GET_SISS_URL: {
        return { ...state, bankfeeds: { ...state.bankfeeds, sissURL: action.payload }};
    }

    case constants.BANKFEEDS_SET_API_ERROR:
      return { ...state, apiError: action.payload };

    case constants.BANKFEEDS_LOAD_COMPLETED:
      return { ...state, loadCompleted: true };

    case constants.GET_BANKFEED_OPTIONS: 
        return { ...state, bankfeedOptions: action.payload };

    case constants.REQUEST_BANKFEED_SHARES:
        return { ...state, feedLoading: true, added: false };
    
    case constants.GET_BANKFEED_SHARES:
        return { ...state, shareList: action.payload, feedLoading: false, error: '' };

    case constants.REQUEST_ADD_BANKFEED_SHARE:
        return { ...state, adding: true, error: '' };

    case constants.ADD_BANKFEED_SHARE:
        return { ...state, adding: false, added: true, error: '' };

    case constants.ADD_BANKFEED_SHARE_FAILURE:
        return { ...state, error: action.error, adding: false };
    
    case constants.REQUEST_DELETE_BANKFEED_SHARE:
        return { ...state, feedLoading: true };

    case constants.DELETE_BANKFEED_SHARE:
        return { ...state };
    
    case constants.DELETE_BANKFEED_SHARE_FAILURE:
        return { ...state, feedLoading: false };
    
    case constants.REQUEST_SEND_EMAIL:
        return { ...state, sending: true, error: '' };
    
    case constants.SEND_EMAIL:
        return { ...state, sending: false, sent: true, error: '' };

    case constants.SEND_EMAIL_FAILURE:
        return { ...state, error: action.payload, sending: false };

    case constants.CLEAR_SHARE_STATE:
        return { ...state, error: '', adding: false, added: false, sending: false, sent: false };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/bankfeedsReducer.js